import { Component, Event, EventEmitter, Fragment, h, Prop } from '@stencil/core';

@Component({
  tag: 'search-wrapper',
  styleUrls: ['search-wrapper.css', '../../global/app.css'],
  shadow: true,
})
export class SearchWrapper {
  @Prop() isSearching: boolean = false;

  render() {
    return (
      <Fragment>
        {this.isSearching && <slot name="search-results"></slot>}
        {!this.isSearching && <slot></slot>}
      </Fragment>
    );
  }
}
